import {
  Component,
  OnInit,
} from '@angular/core';
import * as dayjs from 'dayjs';
import { Observable } from 'rxjs';
import { UserDetails } from 'src/app/interfaces/UserDetails';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-black-friday-banner',
  templateUrl: './black-friday-banner.component.html',
  styleUrls: ['./black-friday-banner.component.scss'],
})
export class BlackFridayBanner implements OnInit {
  user$: Observable<UserDetails>;
  hidden = true;
  closedDates: string[] = [];

  bannerText: string[] = [
    'black friday is here',
    '40% off all premium plans',
    'play without ads',
    'access the archives',
    'use code blackfriday25',
  ];
  localStorageKey = 'scrolling-black-friday-2025-prompt-closed-dates';

  constructor(private user: UserService) {
    this.user$ = this.user.getUserDetails();
    this.handleClose = this.handleClose.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  ngOnInit() {
    const saved = localStorage.getItem(this.localStorageKey);
    this.closedDates = saved ? JSON.parse(saved) : [];

    this.user$.subscribe((user) => {
      this.evaluateVisibility(user);
    });
  }

  private evaluateVisibility(user: UserDetails | null) {
    // show only Nov 24, 2025
    if (!dayjs().isSame(dayjs('2025-11-24'), 'day')) {
      this.hidden = true;
      return;
    }

    // hide if user is premium
    if (user?.premiumGames?.length) {
      this.hidden = true;
      return;
    }

    // hide if closed previously
    if (this.closedDates.length > 0) {
      this.hidden = true;
      return;
    }

    this.hidden = false;
  }

  handleClose = () => {
    this.hidden = true;

    const now = new Date().toISOString();
    this.closedDates.push(now);

    localStorage.setItem(
      this.localStorageKey,
      JSON.stringify(this.closedDates)
    );
  }

  handleClick = () => {
    window.open('https://account.teuteuf.fr/premium-sign-up', '_blank');
  }
}
